export function retry(fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error)
            return
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject)
        }, interval)
      })
  })
}

export const isUrlValid = (url) => {
  if (typeof url === 'string')
    if (url.indexOf('http') === 0) {
      return true
    } else {
      return false
    }
  return false
}

export const shortenName = (link, maxLength = 25) => {
  if (link.length <= maxLength) {
    return link
  }

  const frontPart = link.substring(0, maxLength - 10)
  const endPart = link.substring(link.length - 5)
  return `${frontPart}...${endPart}`
}
